import React from 'react'
import SvgPhone from '@/src/assets/svgs/collection/phone-call.svg'
import styles from './styles.module.scss'

type PhoneNumberProps = {
    phone: string
    text?: string
    showSvg: boolean
    showPhone: boolean
}

export default function PhoneNumber({ phone, text, showSvg, showPhone }: PhoneNumberProps) {
    return (
        <a href={`tel:${phone}`} className={styles.callArea}  >
            {showSvg &&
                <SvgPhone className={styles.phoneSvg} />
            }
            <p>{text ? text : ''} {showPhone && phone}</p>
        </a>
    )
}